import { render, staticRenderFns } from "./ScanLogin.vue?vue&type=template&id=480fecd0&scoped=true"
import script from "./ScanLogin.vue?vue&type=script&lang=js"
export * from "./ScanLogin.vue?vue&type=script&lang=js"
import style0 from "./ScanLogin.vue?vue&type=style&index=0&id=480fecd0&prod&scoped=true&lang=css"
import style1 from "./ScanLogin.vue?vue&type=style&index=1&id=480fecd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fecd0",
  null
  
)

export default component.exports